import { render } from "./ConfirmEmailChangePage.vue?vue&type=template&id=58fd2988&scoped=true"
import script from "./ConfirmEmailChangePage.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailChangePage.vue?vue&type=script&lang=js"

import "./ConfirmEmailChangePage.vue?vue&type=style&index=0&id=58fd2988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fd2988"]])

export default __exports__